import React from "react";

var ChevronRight = function ChevronRight() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5156 7.98438C11.8203 8.26562 11.8203 8.75781 11.5156 9.03906L7.01562 13.5391C6.73438 13.8438 6.24219 13.8438 5.96094 13.5391C5.65625 13.2578 5.65625 12.7656 5.96094 12.4844L9.92188 8.5L5.96094 4.53906C5.65625 4.25781 5.65625 3.76562 5.96094 3.48438C6.24219 3.17969 6.73438 3.17969 7.01562 3.48438L11.5156 7.98438Z",
    fill: "#fa6400"
  }));
};

export default ChevronRight;